import api from "./api";

/**
 * Kampanya uçları (backend: /api/campaigns). Yanıtlar ApiResponse zarfında
 * (res.data.data). Liste düz dizi döner.
 */
export const campaignService = {
  list: () => api.get("/campaigns"),
  active: () => api.get("/campaigns/active"),
  get: (id) => api.get(`/campaigns/${id}`),
  create: (payload) => api.post("/campaigns", payload),
  update: (id, payload) => api.put(`/campaigns/${id}`, payload),
  setActive: (id, active) =>
    api.patch(`/campaigns/${id}/status`, null, { params: { active } }),
  remove: (id) => api.delete(`/campaigns/${id}`),
};
